/**
 * The phone the product is designed against — 390×844, the iPhone 14/15 logical size.
 *
 * Here because these are pixel values and this package is the one place allowed to hold
 * them, so a resize is a token edit rather than a search. Narrow enough that a layout
 * passing here passes wider, and unitless like the rest: React Native takes
 * density-independent pixels and the web builds a length from a number.
 */
export const device = {
    width: 390,
    height: 844,
};
/**
 * The handset drawn around the preview in the authoring console — GEN-80.
 *
 * Beside `device` because it is the same measurement: `bezel` is *outside* the screen, so
 * the lesson still gets exactly `device` pixels. Padding inward would render it narrower
 * than the phone it claims to be, which is the one mistake the pane exists to avoid.
 *
 * The island and the indicator are decoration and take no pointer events. `insets` are
 * the iPhone 14's safe area, so the lesson clears them as it would on the phone: the
 * island ends at 44 and the indicator starts 13 from the bottom — LESSON-25.
 */
export const handset = {
    bezel: 12,
    island: { width: 118, height: 34, top: 10 },
    indicator: { width: 138, height: 5, bottom: 8 },
    insets: { top: 47, bottom: 34 },
};
//# sourceMappingURL=device.js.map